import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { headingRecipe, HeadingRecipeRecipe, HeadingRecipeVariantProps } from "@fenderdigital/ui-styled-system/recipes";
import { FontSizeToken } from "@fenderdigital/ui-styled-system/tokens";
import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { css, cx } from "styled-system/css";

@Component({
  selector: "fui-heading",
  templateUrl: "heading.component.html",
  standalone: false,
})
export class FuiHeadingComponent extends BaseComponent implements OnInit {
  public usePanda: boolean = true;
  @Input() text: string;
  @Input() props: HeadingRecipeVariantProps = {};
  @Input() color: string;
  @Input() fontSize: FontSizeToken;
  @Input() extraClasses: string;
  @Input() level: string = "1";
  @Input() textAlign: string = "left";
  headingRecipe = headingRecipe;
  public value: any;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {
    // Set the level in props for the Panda CSS recipe, but keep this.level for the template
    if (this.usePanda) {
      const recipeProps = { ...this.props, level: this.level as "1" | "2" | "3" | "4" | "5" | "6" | "undefined" };
      let myClassName = cx(this.headingRecipe({ ...recipeProps }), css({ color: this.color }), css({ fontSize: this.fontSize }), css({ textAlign: this.textAlign }));
      this.value = myClassName;
    } else {
      this.value = "fui-heading-" + this.level;
    }
    if (this.extraClasses) {
      this.value = this.value + " " + this.extraClasses;
    }
  }
}
